import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { BalconyOptions } from '@search/filter-enums/enums/BalconyOptions';
import { BalconyFilter } from '../../../../models/Filter';

interface IBalconyNewFilter {
    filter: BalconyFilter;
    handleChange: (value: BalconyFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<BalconyOptions>[] = [
    { label: 'С балконом или лоджией', value: BalconyOptions.HAS_ANY }

];

export const BalconyNewFilter: React.FC<IBalconyNewFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean) => {
        value ?
            handleChange(new BalconyFilter(BalconyOptions.HAS_ANY)) :
            handleChange(new BalconyFilter(BalconyOptions.UNKNOWN));
    }, [ handleChange ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ label, value }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter.hasBalcony === BalconyOptions.HAS_ANY}
                        onChange={onChange}
                        variant='filter'
                        dataTest='balcony'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
